import { AgsInitState } from "ags/state-machine/states/ags-init-state";

export class ThemeInitState extends AgsInitState {
    public onExit() {

    }
}
